module.exports = __webpack_public_path__ + "media/images/squadBet__teamPlaceholder-1a55d9c41ff613754cd0973118a89eed.png";